import React, { useEffect } from "react";
import { Link, useNavigationType, useParams } from "react-router-dom";
import { dishes, fullName, menuCategories as cues } from "../data/dishes";
import { findCategory } from "../data/menu";
import { useTheme, useDocumentTitle } from "../hooks/useSite";
import FoodImage from "../components/FoodImage";
import FullMenu from "../components/FullMenu";

export default function MenuPage() {
  const { categorySlug } = useParams();
  const navType = useNavigationType();
  const category = findCategory(categorySlug);
  useTheme(dishes[0]);
  useDocumentTitle(category ? `${category.name} · Our Menu` : "Our Menu");

  // Direct loads and Back/Forward onto a category route land on the full menu.
  useEffect(() => {
    if (categorySlug && navType !== "PUSH") {
      const el = document.getElementById("full-menu");
      if (el) el.scrollIntoView({ block: "start" });
    }
  }, [categorySlug, navType]);

  return (
    <>
      <section className="ro-collection-intro">
        <div className="ro-container">
          <h1>
            <strong className="ro-italic">Our</strong>
            <br />
            <span className="ro-outline">Delicious Cravings</span>
          </h1>
          <p className="ro-lead">
            A little sweet, a little savoury. <strong>Your mood. Your RollOver.</strong>
          </p>
          <ul className="ro-five">
            {cues.map((c) => (
              <li key={c.title}>
                <strong>{c.title}</strong>
                <br />
                {c.sub}
              </li>
            ))}
          </ul>
        </div>
      </section>
      <section className="ro-section ro-section--showcase">
        <div className="ro-container">
          <h2 className="ro-collection-sub">
            Seven to <span className="ro-outline">start with.</span>
          </h2>
          <div className="ro-collection-grid">
            {dishes.map((d) => (
              <Link key={d.id} to={`/menu/${d.id}`} className="ro-card" style={{ "--ro-theme": d.colour, "--ro-pale": d.pale }}>
                <div className="ro-card__tile">
                  <FoodImage dish={d} alt="" />
                </div>
                <h3>{fullName(d)}</h3>
                <p>{d.desc}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <FullMenu categorySlug={categorySlug} />
    </>
  );
}
